import { API } from "aws-amplify";
import { getMoveExam } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_MOVE_EXAM_INFO: APITypes.MoveExam = {
  id: "",
  startDate: "",
  endDate: "",
  __typename: "MoveExam",
  type: APITypes.MoveExamType.IN,
  status: APITypes.MoveExamStatusType.Pending,
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getMoveExamInfo = async (
  leaseID: string
): Promise<LoaderData<APITypes.MoveExam>> => {
  try {
    const response = (await API.graphql({
      query: getMoveExam,
      variables: {
        id: leaseID,
      },
    })) as { data?: APITypes.GetMoveExamQuery };

    return {
      success: true,
      data: response.data?.getMoveExam || EMPTY_MOVE_EXAM_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_MOVE_EXAM_INFO,
      error,
    };
  }
};
